import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { OrgManagementView } from "@/features/organizations/components/OrgManagementView"

export const Route = createFileRoute("/_authed/organizations")({
  component: OrganizationsPage,
})

function OrganizationsPage() {
  const { t } = useTranslation("organizations")
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <OrgManagementView />
    </div>
  )
}
